import styled from "@emotion/styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { UploadPhotoModal } from "src/components/NewComponents/Modals/UploadFiles/UploadPhotoModal";
import { useSlot } from "src/components/Slots/SlotsContext";
import Editor from "../../../../TextEditor";
import Gallery from "../../../Images/Gallery";

function AddCommentField({
	onSubmit,
	commentImage,
	setCommentImage,
	className,
	placeholder,
	submitText,
	parent,
}) {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	// admin odpowiada w swoim edytorze (z AI); klient nie ma tego slotu
	const ReplyEditorSlot = useSlot("commentReplyEditor");

	const openUploadModal = () => {
		setIsUploadModalOpen(true);
	};

	const renderUploadModal = () => {
		if (!isUploadModalOpen) {
			return null;
		}

		return (
			<UploadPhotoModal
				onClose={() => setIsUploadModalOpen(false)}
				onConfirm={setCommentImage}
			/>
		);
	};

	const renderGallery = () => {
		if (!commentImage) {
			return null;
		}

		return (
			<Gallery
				images={[
					{
						image: commentImage.image.path,
						title: commentImage.image.name,
					},
				]}
				onDelete={() => setCommentImage(null)}
			/>
		);
	};

	const submit = async (htmlString) => {
		try {
			setIsLoading(true);
			await onSubmit(htmlString);
			const isCommentWithCustomSource = commentImage
				? !commentImage.source.id
				: false;
			toast[isCommentWithCustomSource ? "info" : "success"](
				isCommentWithCustomSource
					? t("success.commentWaiting")
					: t("success.commentAdded"),
				{
					position: toast.POSITION.BOTTOM_LEFT,
					pauseOnHover: false,
					autoClose: isCommentWithCustomSource ? 5000 : 3000,
				},
			);
			setCommentImage(null);
			setIsLoading(false);
		} catch (err) {
			setIsLoading(false);
			const errorKey =
				err.response?.status === 429
					? "errors.tooManyRequests"
					: "errors.addCommentProblem";
			toast.error(t(errorKey), {
				position: toast.POSITION.BOTTOM_LEFT,
				pauseOnHover: false,
				autoClose: 3000,
			});
			throw new Error("Error adding comment");
		}
	};

	if (ReplyEditorSlot && parent?.questionId) {
		return (
			<div className={className}>
				<ReplyEditorSlot
					comment={parent}
					placeholder={placeholder}
					submitText={submitText}
					onSubmit={submit}
				/>
			</div>
		);
	}

	return (
		<div className={className}>
			<Editor
				placeholder={placeholder}
				isLoading={isLoading}
				onSubmit={submit}
				submitText={submitText}
				clearAfterSave
				disabled={!commentImage}
				openUploadModal={openUploadModal}
				gallery={renderGallery()}
			/>
			{renderUploadModal()}
		</div>
	);
}

AddCommentField.defaultProps = {
	className: "",
	placeholder: "",
	submitText: "",
	commentImage: null,
	parent: null,
};

export default styled(AddCommentField)``;
